export const environment = {
  isProdEnv: true,
  production: true,
  i18nDirectory: "./assets/i18n/",
  application_url: "https://www.geologyontario.mines.gov.on.ca/",
  apim_url: "https://ws.apis.lrc.gov.on.ca/mndm/geology/search",
  serviceSubscriptionKey: '6ac44311ef5c4a6899e7a0f25ddd1715',
  azure_blob_storage: "https://prd-0420-geoontario-0000-blob-cge0eud7azhvfsf7.z01.azurefd.net/lrc-geology-documents/"
};